// extracted by mini-css-extract-plugin
export default {"heading":"Contact_heading__NhaTc","main":"Contact_main__xTyvR","section_a":"Contact_section_a__ZTJPC","left-side":"Contact_left-side__+3C7U","right-side":"Contact_right-side__HuHDq"};